export class PermissionsEnum {
  static UPLOAD_PERMISSION = 'UPLOAD';
  static CHANNEL_ACCESS = 'CHANNEL_ACCESS';
}
